var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.49184 15.3307C6.21988 15.2208 6.06969 15.1676 5.98568 15.1779C5.88242 15.1905 5.7326 15.3004 5.43296 15.5203C4.90466 15.9081 4.2391 16.1865 3.25209 16.1626C2.75299 16.1505 2.50344 16.1445 2.39173 15.9549C2.28001 15.7654 2.41915 15.503 2.69743 14.9781C3.08337 14.2503 3.32791 13.4169 2.95737 12.7493C2.31921 11.7956 1.77715 10.6662 1.69794 9.44633C1.65538 8.79091 1.65538 8.11216 1.69794 7.45674C1.91542 4.10752 4.55856 1.43969 7.87678 1.22017C9.00653 1.14544 10.1885 1.14528 11.3205 1.22017C14.6246 1.43876 17.2594 4.08488 17.4964 7.41406",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.2467 17.5367C10.1552 17.4025 8.48924 15.7722 8.35215 13.7255C8.32532 13.3249 8.32532 12.9101 8.35215 12.5096C8.48924 10.4628 10.1552 8.8325 12.2467 8.69835C12.9603 8.65259 13.7052 8.65268 14.4173 8.69835C16.5088 8.8325 18.1748 10.4628 18.3119 12.5096C18.3387 12.9101 18.3387 13.3249 18.3119 13.7255C18.262 14.4709 17.9203 15.1611 17.5181 15.7439C17.2845 16.1519 17.4387 16.6612 17.6819 17.106C17.8573 17.4267 17.945 17.5871 17.8746 17.7029C17.8042 17.8188 17.6469 17.8225 17.3323 17.8299C16.7102 17.8445 16.2907 17.6743 15.9577 17.4374C15.7688 17.303 15.6744 17.2358 15.6093 17.2281C15.5442 17.2203 15.4161 17.2712 15.16 17.373C14.9298 17.4645 14.6626 17.521 14.4173 17.5367C13.7052 17.5824 12.9603 17.5825 12.2467 17.5367Z",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.fc5f8ef571ed566d7a1b1800746c0299.svg";
export { ForwardRef as ReactComponent };